import { AloActivity } from './AloActivity';
import { AloAddress, getDefaultAloAddress } from './AloAddress';
import { AloBase, getDefaultAloBase } from './AloBase'
import { AloMedia, getDefaultAloMedia } from './AloMedia';
import { AloPageContent, getDefaultAloPageContent } from './AloPageContent';
import { AloTemplateHoraire, cleanAloTemplateHoraire } from './AloTemplateHoraire';


export interface AloTemplateCours extends AloBase {      
    acyId:number    
    psnId:number
    tcsDureeMin:number
    tcsCapaciteMax:number
    horaires:AloTemplateHoraire[]
}

export const getDefaultAloTemplateCours = (psnId:number=0,activity?:AloActivity):AloTemplateCours => {
    return {  
        ...getDefaultAloBase(),        
        libelle:activity?.libelle??"",
        acyId:activity?.id || 5,
        psnId:psnId,
        tcsDureeMin:45,
        tcsCapaciteMax:8,
        horaires:[]
    }
}

export const cleanAloTemplateCours = (tplCours:AloTemplateCours) => {
    if(!tplCours) return    
    if(!tplCours.id) delete tplCours.id
    if(!tplCours.psnId) delete tplCours.psnId    
    if(!tplCours.acyId) delete tplCours.acyId    
    tplCours.horaires.forEach(h => cleanAloTemplateHoraire(h))
    
}